// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"3897ad15","405":"d9b31d1c","483":"d2db38ab","715":"ec83c7d8","754":"007f0391"}[chunkId] + ".chunk.js";
};